import { get } from './base'

const endpoint = '/api/v2/costCenters'

export function getAll() {
  return get(endpoint)
}
